var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-text":"Web","inactive-text":"App"},model:{value:(_vm.presence),callback:function ($$v) {_vm.presence=$$v},expression:"presence"}})
}
var staticRenderFns = []

export { render, staticRenderFns }